// src/components/FollowUpModal.js
import React, { useState } from 'react';

function FollowUpModal({ isOpen, onClose, oportunidade, onConfirmar }) {
  const [observacao, setObservacao] = useState('');
  const [enviando, setEnviando] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Verificação de limite
    if (followupsRealizados >= 3) {
      alert('⚠️ Limite de 3 contatos atingido!\n\nVocê já registrou 3 tentativas de contato. Agora deve reprovar o orçamento.');
      onClose();
      return;
    }
    
    if (!observacao.trim()) {
      alert('Digite o que foi conversado com o cliente!');
      return;
    }
    
    if (observacao.trim().length < 10) {
      alert('A observação deve ter pelo menos 10 caracteres!');
      return;
    }
    
    setEnviando(true);
    
    try {
      // Enviar apenas a string de observação
      await onConfirmar(observacao.trim());
      setObservacao('');
      onClose();
    } catch (error) {
      console.error('Erro ao salvar follow-up:', error);
      
      // Mostrar mensagem de erro mais detalhada
      const mensagemErro = error.response?.data?.error || error.message || 'Erro desconhecido';
      alert('Erro ao salvar follow-up:\n\n' + mensagemErro);
    } finally {
      setEnviando(false);
    }
  };

  if (!isOpen) return null;

  const getNumeroOS = () => {
    const match = oportunidade?.titulo?.match(/OS (\d+)/);
    return match ? match[1] : '';
  };

  const followupsRealizados = oportunidade?.followups_realizados || 0;
  const followupsRestantes = 3 - followupsRealizados;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>📞 Registrar Contato com Cliente - OS #{getNumeroOS()}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="info-section">
              <p style={{marginBottom: '10px'}}>
                <strong>Cliente:</strong> {oportunidade?.cliente_nome}
              </p>
              
              <div style={{
                background: '#e3f2fd',
                padding: '12px',
                borderRadius: '8px',
                marginBottom: '20px',
                border: '1px solid #2196f3'
              }}>
                <p style={{margin: 0, fontSize: '14px', color: '#1976d2'}}>
                  📊 <strong>Follow-ups:</strong> {followupsRealizados}/3 realizados
                  {followupsRestantes > 0 && (
                    <span style={{marginLeft: '10px'}}>
                      | 🎯 Restam <strong>{followupsRestantes}</strong> tentativa{followupsRestantes > 1 ? 's' : ''}
                    </span>
                  )}
                </p>
              </div>

              {followupsRealizados >= 3 && (
                <div style={{
                  background: '#fee2e2',
                  padding: '15px',
                  borderRadius: '8px',
                  border: '1px solid #dc2626',
                  marginBottom: '20px'
                }}>
                  <p style={{margin: 0, fontSize: '14px', color: '#dc2626', fontWeight: 'bold'}}>
                    🚫 <strong>LIMITE ATINGIDO!</strong>
                  </p>
                  <p style={{margin: '8px 0 0 0', fontSize: '14px', color: '#dc2626'}}>
                    Você já registrou 3 tentativas de contato. Não é possível adicionar mais. 
                    Agora você deve reprovar o orçamento.
                  </p>
                </div>
              )}

              {followupsRealizados < 3 && followupsRealizados >= 2 && (
                <div style={{
                  background: '#fff3cd',
                  padding: '15px',
                  borderRadius: '8px',
                  border: '1px solid #ffc107',
                  marginBottom: '20px'
                }}>
                  <p style={{margin: 0, fontSize: '14px'}}>
                    ⚠️ <strong>Atenção:</strong> Este é o {followupsRealizados === 2 ? 'último' : 'penúltimo'} registro permitido. 
                    Após salvar, você {followupsRealizados === 2 ? 'deverá reprovar o orçamento se não houver aprovação' : 'terá apenas mais 1 tentativa'}.
                  </p>
                </div>
              )}
              
              <div className="form-group">
                <label>O que foi conversado com o cliente? *</label>
                <textarea
                  value={observacao}
                  onChange={(e) => setObservacao(e.target.value)}
                  placeholder="Ex: Cliente solicitou desconto de 10%. Informou que vai decidir até sexta-feira..."
                  rows="8"
                  required
                  disabled={followupsRealizados >= 3}
                  style={{
                    width: '100%',
                    padding: '10px',
                    borderRadius: '4px',
                    border: '1px solid #ddd',
                    fontSize: '14px',
                    fontFamily: 'inherit',
                    resize: 'vertical',
                    opacity: followupsRealizados >= 3 ? 0.5 : 1
                  }}
                />
                <small>
                  Mínimo 10 caracteres. Esta informação será salva no histórico do Gestão Click 
                  com data e hora.
                </small>
              </div>

              <div style={{
                background: '#f5f5f5',
                padding: '15px',
                borderRadius: '8px',
                marginTop: '20px'
              }}>
                <p style={{margin: 0, fontSize: '13px', color: '#666'}}>
                  💡 <strong>Dica:</strong> Registre informações importantes como:
                </p>
                <ul style={{marginTop: '8px', marginBottom: 0, paddingLeft: '20px', fontSize: '13px', color: '#666'}}>
                  <li>Feedback do cliente sobre o orçamento</li>
                  <li>Objeções ou dúvidas levantadas</li>
                  <li>Prazos ou compromissos acordados</li>
                  <li>Negociações em andamento</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button 
              type="button" 
              onClick={onClose} 
              className="btn-secondary"
              disabled={enviando}
            >
              {followupsRealizados >= 3 ? 'Fechar' : 'Cancelar'}
            </button>
            {followupsRealizados < 3 && (
              <button 
                type="submit" 
                className="btn-primary"
                disabled={enviando}
                style={{
                  backgroundColor: '#2196f3',
                  color: 'white'
                }}
              >
                {enviando ? '⏳ Salvando...' : '💾 Salvar Contato'}
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default FollowUpModal;
